import { render } from "./ImageCopyright.vue?vue&type=template&id=710f4d96&scoped=true"
import script from "./ImageCopyright.vue?vue&type=script&lang=js"
export * from "./ImageCopyright.vue?vue&type=script&lang=js"

import "./ImageCopyright.vue?vue&type=style&index=0&id=710f4d96&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-710f4d96"]])

export default __exports__